<kendo-formfield>
    <kendo-label [text]="caption | translate" ></kendo-label>
    <kendo-combobox #listCombo [ngClass]="{'fx-fill': settings.fxFill}" [data]="valuesList$ | async" [textField]="textField"
        [valueField]="valueField" [valuePrimitive]="true" [formControl]="control" [filterable]="true" (valueChange)="onChange($event)"
        [kendoDropDownFilter]="filterSettings">
         <ng-template kendoComboBoxItemTemplate let-listItem>

            <div fxFill  class="list-item-display">
                {{ listItem[textField] }}
            </div>

        </ng-template> 
    </kendo-combobox>
</kendo-formfield> 